const RECORDER_MIME_CANDIDATES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4',
  'audio/ogg;codecs=opus',
  'audio/ogg',
]

export const getSupportedRecorderMimeType = (): string => {
  if (typeof MediaRecorder === 'undefined' || typeof MediaRecorder.isTypeSupported !== 'function') {
    return ''
  }

  return RECORDER_MIME_CANDIDATES.find((mimeType) => MediaRecorder.isTypeSupported(mimeType)) ?? ''
}

export const getAudioMimeWithoutCodecs = (mimeType: string): string => {
  return mimeType.split(';')[0]?.trim().toLowerCase() || 'audio/webm'
}

export const getExtensionFromMimeType = (mimeType: string): string => {
  const normalized = getAudioMimeWithoutCodecs(mimeType)

  if (normalized.includes('webm')) return 'webm'
  if (normalized.includes('mp4') || normalized.includes('m4a')) return 'm4a'
  if (normalized.includes('ogg') || normalized.includes('opus')) return 'ogg'

  return 'webm'
}
